(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  function initDivergeCouponBar(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-coupon-bar]').forEach(function (bar) {
      if (bar.dataset.rotationBound === 'true') return;

      var viewport = bar.querySelector('.announcement-promo-carousel__viewport');
      var items = bar.querySelectorAll('.announcement-promo-slide');
      if (!viewport || !items.length) return;

      bar.dataset.rotationBound = 'true';
      var interval = parseInt(bar.dataset.rotateInterval, 10) || 5000;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var current = 0;
      var timer = null;
      var animating = false;

      function syncChromeHeight() {
        var maxHeight = 0;
        items.forEach(function (item) {
          var previousVisibility = item.style.visibility;
          var wasWaiting = item.classList.contains('is-waiting');
          if (wasWaiting) {
            item.classList.remove('is-waiting');
            item.style.visibility = 'hidden';
          }
          maxHeight = Math.max(maxHeight, item.offsetHeight);
          if (wasWaiting) {
            item.classList.add('is-waiting');
            item.style.visibility = previousVisibility;
          }
        });
        if (maxHeight) viewport.style.minHeight = maxHeight + 'px';
        document.documentElement.style.setProperty('--site-chrome-bar-height', bar.offsetHeight + 'px');
      }

      function resetSlide(item, state) {
        item.classList.remove('is-active', 'is-waiting', 'is-entering', 'is-exiting', 'is-entering--run', 'is-exiting--run');
        if (state === 'active') item.classList.add('is-active');
        if (state === 'waiting') item.classList.add('is-waiting');
      }

      function setInitialState() {
        items.forEach(function (item, index) {
          resetSlide(item, index === 0 ? 'active' : 'waiting');
          item.toggleAttribute('aria-hidden', index !== 0);
        });
        current = 0;
        syncChromeHeight();
      }

      function advance() {
        if (animating || items.length < 2) return;

        var next = (current + 1) % items.length;
        var outgoing = items[current];
        var incoming = items[next];

        if (reduceMotion) {
          resetSlide(outgoing, 'waiting');
          outgoing.setAttribute('aria-hidden', 'true');
          resetSlide(incoming, 'active');
          incoming.removeAttribute('aria-hidden');
          current = next;
          syncChromeHeight();
          return;
        }

        animating = true;
        outgoing.classList.remove('is-active');
        outgoing.classList.add('is-exiting');
        incoming.classList.remove('is-waiting');
        incoming.classList.add('is-entering');
        incoming.removeAttribute('aria-hidden');

        window.requestAnimationFrame(function () {
          outgoing.classList.add('is-exiting--run');
          incoming.classList.add('is-entering--run');
        });

        var finished = false;
        function finishTransition() {
          if (finished) return;
          finished = true;
          resetSlide(outgoing, 'waiting');
          outgoing.setAttribute('aria-hidden', 'true');
          resetSlide(incoming, 'active');
          current = next;
          animating = false;
          syncChromeHeight();
        }

        incoming.addEventListener('transitionend', function (event) {
          if (event.propertyName === 'transform') finishTransition();
        }, { once: true });
        window.setTimeout(finishTransition, 700);
      }

      function stop() {
        if (timer) window.clearInterval(timer);
        timer = null;
      }

      function start() {
        stop();
        setInitialState();
        if (items.length < 2 || reduceMotion) return;
        timer = window.setInterval(advance, interval);
      }

      window.addEventListener('resize', syncChromeHeight);
      start();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initDivergeCouponBar();
    });
  } else {
    initDivergeCouponBar();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initDivergeCouponBar(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
